import dayjs from 'dayjs';

import utc from 'dayjs/plugin/utc';

const shortMonth = 'MMM D, YYYY, h:mm a';
export const longMonth = 'MMMM D, YYYY, h:mm a';

export function formatDate(dateString, format = longMonth): string {
	return dayjs(dateString).format(format);
}

function formatDateToUtc(dateString, format = longMonth): string {
	const utcDayjs = dayjs.extend(utc).utc(dateString);
	return utcDayjs.format(format);
}

export function formatShortMonthDatetime(dateString, toUtc = false): string {
	return toUtc ? formatDateToUtc(dateString, shortMonth) : formatDate(dateString, shortMonth);
}

// ============================================================================
// GraphQL Date Utilities
// ============================================================================
// Utilities for formatting dates for GraphQL queries (not for display)

const ISO_MILLISECONDS_SUFFIX = /\.\d{3}Z$/;

/**
 * Gets the UTC start of day for a given date
 * @param date - The date to get UTC start of day for
 * @returns A new Date object set to UTC midnight
 */
const getUtcStartOfDay = (date: Date): Date =>
	new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

/**
 * Formats a date for GraphQL queries by removing milliseconds from ISO string
 * @param date - The date to format
 * @returns ISO string without milliseconds (e.g., "2025-12-18T00:00:00Z")
 */
export const formatDateForGraphQL = (date: Date): string =>
	date.toISOString().replace(ISO_MILLISECONDS_SUFFIX, 'Z');

export const calculateRecentPeriodDates = (
	periodDays: number
): { today: Date; recentPeriodStart: Date } => {
	const today = getUtcStartOfDay(new Date());
	const recentPeriodStart = new Date(today);
	recentPeriodStart.setUTCDate(today.getUTCDate() - periodDays);
	return { today, recentPeriodStart };
};
